import { Component } from "react";
import { connect } from "react-redux";

import { redirectTo } from "../utils/browserUtils";

import { sessionExpired } from "../actions";
import { locationShape, sessionShape } from "../shapes";

const deviceViewerPathRegex = /^\/app\/.*\/device_viewer/;

type OwnSessionHandlerProps = {
  dispatch?: $TSFixMeFunction;
  location?: locationShape;
  session?: sessionShape;
  unsecuredEndpoints?: string[];
};

const defaultProps: Partial<OwnSessionHandlerProps> = {
  unsecuredEndpoints: [],
};

type SessionHandlerProps = OwnSessionHandlerProps & typeof defaultProps;
class SessionHandler extends Component<SessionHandlerProps> {
  static readonly defaultProps = defaultProps;

  sessionTimerId: $TSFixMe;

  componentDidMount() {
    this.handleLocation(this.props);
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    this.handleSessionTimeout(this.props.session.sessionExpiresAt - Date.now());

    window.addEventListener("focus", () => {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      if (this.props.session.sessionExpiresAt <= Date.now()) {
        // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        this.props.dispatch(sessionExpired());
      } else {
        this.handleSessionTimeout(
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          this.props.session.sessionExpiresAt - Date.now(),
        );
      }
    });
  }

  componentDidUpdate(prevProps: SessionHandlerProps) {
    const { session } = prevProps;
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    if (session.sessionExpiresAt !== this.props.session.sessionExpiresAt) {
      this.handleSessionTimeout(
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        this.props.session.sessionExpiresAt - Date.now(),
      );
    }
    this.handleLocation(this.props);
  }

  /* eslint-disable consistent-return */
  handleLocation(props: $TSFixMe) {
    const { session, location, unsecuredEndpoints } = props;

    /* istanbul ignore next */
    if (location.pathname.match(/^\/app\/.*\/legal/)) {
      return;
    }

    if (session.sessionDeleted) {
      return redirectTo("/logout");
    }
    if (session.sessionExpired && location.pathname !== "/session_expired") {
      if (location.pathname.match(deviceViewerPathRegex)) {
        return redirectTo("/device_viewer/session_expired");
      }
      return redirectTo("/session_expired");
    }
    if (
      !session.authenticated &&
      unsecuredEndpoints.indexOf(location.pathname) < 0 &&
      !location.pathname.match(deviceViewerPathRegex)
    ) {
      return redirectTo("/");
    }
  }
  /* eslint-enable consistent-return */

  handleSessionTimeout(timeout: $TSFixMe) {
    if (this.sessionTimerId) {
      clearTimeout(this.sessionTimerId);
    }
    this.sessionTimerId = setTimeout(() => {
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      this.props.dispatch(sessionExpired());
    }, timeout);
  }

  render() {
    // @ts-expect-error TS(2339) FIXME: Property 'children' does not exist on type 'Readon... Remove this comment to see the full error message
    const { session, location, children, unsecuredEndpoints } = this.props;
    if (
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      session.authenticated ||
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      unsecuredEndpoints.indexOf(location.pathname) >= 0 ||
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      location.pathname.match(deviceViewerPathRegex) ||
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      location.pathname.match(/^\/app\/.*\/legal/)
    ) {
      return <div>{children}</div>;
    }
    return null;
  }
}

const mapStateToProps = (state: $TSFixMe) => ({
  session: state.session,
});

// @ts-expect-error TS(2345) FIXME: Argument of type 'typeof SessionHandler' is not as... Remove this comment to see the full error message
export default connect(mapStateToProps)(SessionHandler);
